import * as React from "react";
const Flag = ({ title, titleId, desc, descId }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 96 96", "aria-labelledby": titleId, "aria-describedby": descId },
    desc ? React.createElement("desc", { id: descId }, desc) : null,
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("mask", { id: "prefix__a", width: 96, height: 96, x: 0, y: 0, maskUnits: "userSpaceOnUse", style: {
            maskType: "luminance",
        } },
        React.createElement("path", { fill: "#fff", d: "M95.5.5H.5v95h95z" })),
    React.createElement("g", { mask: "url(#prefix__a)" },
        React.createElement("path", { fill: "#ED0000", d: "M55.9 16.4V.6H8.5V48h31.6v15.8h47.4V16.4z" }),
        React.createElement("path", { fill: "#3F3F3F", d: "M40.1 48v15.8L55.9 48z" }),
        React.createElement("path", { fill: "#CFCFCF", d: "M24.3 48H8.5v47.4h15.8z" }))));
export default Flag;
//# sourceMappingURL=Flag.js.map